import { tv } from 'tailwind-variants'

export const alertVariants = tv({
  slots: {
    root: [
      'flex flex-row items-center',
      'rounded-md p-3',
      'bg-paper-elevation4 text-text-primary',
      'border border-secondary-main',
      'max-w-[900px]',
      'sm:flex-col sm:items-center sm:gap-2',
    ],
    icon: ['my-auto pr-2', '[&_svg]:size-6', 'sm:p-1 sm:[&_svg]:size-[30px]'],
    message: [
      'flex w-full flex-auto gap-1',
      'sm:flex-col sm:items-center sm:justify-center sm:gap-2 sm:text-center',
    ],
    messageInner: ['flex max-w-full flex-auto flex-col justify-center gap-1'],
    title: 'm-0 break-words text-pretty',
    actions: [
      'flex flex-none flex-row items-center gap-2 ml-4',
      '[&_svg]:size-5 [&_svg]:text-text-secondary',
      'sm:ml-0',
    ],
  },
  variants: {
    severity: {
      error: { root: 'border-error-main', icon: 'text-error-main' },
      warning: { root: 'border-warning-main', icon: 'text-warning-main' },
      info: { root: 'border-info-main', icon: 'text-info-main' },
      success: { root: 'border-primary-main', icon: 'text-primary-main' },
    },
  },
  defaultVariants: {
    severity: 'info',
  },
})
